import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgAttention = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M49.5 25c0 13.531-10.969 24.5-24.5 24.5S.5 38.531.5 25 11.469.5 25 .5 49.5 11.469 49.5 25Z"
      fill="#E02020"
      stroke="#E02020"
    />
    <path
      d="M24.436 30.577h1.798l.464-13.92h-2.726l.464 13.92Zm.899 5.713c.87 0 1.595-.754 1.595-1.595a1.61 1.61 0 0 0-1.595-1.595 1.61 1.61 0 0 0-1.595 1.595c0 .841.725 1.595 1.595 1.595Z"
      fill="#fff"
    />
  </svg>
);
const Memo = memo(SvgAttention);
export default Memo;
